import { Title, TitleProps } from '@mantine/core'
import { ReactNode } from 'react'

interface ResponsiveTitleProps extends Omit<TitleProps, 'children' | 'size'> {
  children: ReactNode
  mobileSize?: TitleProps['size']
  size?: TitleProps['size']
}

/**
 * Responsive title component that renders different sizes for desktop and mobile
 * Desktop: visible from md breakpoint with default size (based on order)
 * Mobile: hidden from md breakpoint with smaller size (default: "2rem")
 * All other Title props are forwarded to both internal Title components
 */
export function ResponsiveTitle({
  children,
  size,
  mobileSize = '2rem',
  ...props
}: ResponsiveTitleProps) {
  return (
    <>
      <Title {...props} visibleFrom="md" size={size}>
        {children}
      </Title>
      <Title {...props} size={mobileSize} hiddenFrom="md">
        {children}
      </Title>
    </>
  )
}
